module.exports = __webpack_public_path__ + "img/Screen2.17c909f8.png";